import { isEmpty } from 'lodash';
import { isRequestedFileFulfilled } from 'common/types/files';
import { ProgressParams, RequestedData } from './getProgressOnRequiredTasks.props';

export const getProgressOnRequiredTasks = ({
  requestedTasksType,
  requestedFiles = [],
  requestedQuestions = [],
  user,
}: ProgressParams): number => {
  const calculateProgress = (answered: number, requestedData: RequestedData): number => {
    if (!answered) {
      return 0;
    }
    return (answered / requestedData.length) * 100;
  };

  if (requestedTasksType === 'documents') {
    if (isEmpty(requestedFiles)) {
      return 0;
    }
    const answered = requestedFiles.filter(item => isRequestedFileFulfilled(item)).length;
    return calculateProgress(answered, requestedFiles);
  }

  if (requestedTasksType === 'questions') {
    if (isEmpty(requestedQuestions)) {
      return 0;
    }
    const answered = requestedQuestions.filter(item => (user ? item.answers?.length > 0 : item.answered)).length;
    return calculateProgress(answered, requestedQuestions);
  }

  return 0;
};
